<template>
    <div id="todo">
        <PageTitle :title="$t('todo.title')">
            <template v-slot:left>
                <i class="fa fa-handshake fa-3x text-primary"/>
            </template>
        </PageTitle>
        <div class="row justify-content-center">
            <div class="col-sm-2">
                <img :src="highFiveSVG" alt="High five"/>
            </div>
        </div>
        <div class="container">
            <section class="row align-items-center padding-top-2x padding-bottom-2x">
                <TodoImprimBook v-if="hermesAPIConfig.client === 'imprimbook'"/>
            </section>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { importSVG } from "@/helpers/file";
import PageTitle from "../../shared/Misc/PageTitle";
import TodoImprimBook from "./TodoImprimBook";

export default {
    name: "Todo",
    components: {
        TodoImprimBook,
        PageTitle},
    computed: {
        ...mapGetters("config", {
            hermesAPIConfig: "hermesAPI",
        }),
        highFiveSVG() {
            return importSVG("high_five", this.hermesAPIConfig.client);
        },
    },
};
</script>

<style scoped>

</style>